import { render, staticRenderFns } from "./employeesCard.vue?vue&type=template&id=7058f24e&"
import script from "./employeesCard.vue?vue&type=script&lang=js&"
export * from "./employeesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports